import React from "react";
import { Chip, alpha } from "@mui/material";
import { statusPalette } from "theme";

// A consistent, theme-aware status pill. Give it any status string
// (order status, payment status, active/inactive…) and it colors itself
// from the shared statusPalette with a soft tinted background.
const StatusChip = ({ status, size = "small", ...rest }) => {
  const key = String(status || "").toLowerCase();
  const color = statusPalette[key] || "#94a3b8";
  const label = status
    ? String(status).charAt(0).toUpperCase() + String(status).slice(1)
    : "—";

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        color,
        backgroundColor: alpha(color, 0.14),
        border: `1px solid ${alpha(color, 0.3)}`,
        fontWeight: 600,
      }}
      {...rest}
    />
  );
};

export default StatusChip;
